import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import { I18n } from 'react-redux-i18n'
import { push } from 'react-router-redux'
import _ from 'lodash'

import api from 'core/api'

const getType = type => `@users/confirmations/${type}`

export const confirmThunk = createActionThunk(
  getType('CONFIRM'),
  api('/users/confirmations', { method: 'PUT' })
)

export const confirm = props => dispatch =>
  dispatch(confirmThunk(props)).then(res => {
    dispatch(push('/users/sign_in'))
    dispatch(toastr.add({ type: 'success', message: I18n.t('devise.confirmations.confirmed') }))
  })

export const sendThunk = createActionThunk(
  getType('SEND'),
  api('/users/confirmations', { method: 'POST' })
)

export const send = props => dispatch =>
  dispatch(sendThunk(props))
    .then(res => {
      dispatch(push('/users/sign_in'))
      dispatch(
        toastr.add({ type: 'success', message: I18n.t('devise.confirmations.send_instructions') })
      )
    })
    .catch(res => {
      if (_.has(res, 'error.error.details') && _.isString(res.error.error.details))
        dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
    })

export const getConfirmationUri = ({ protocol, host }) => `${protocol}//${host}/users/confirmation`
export const getReferralUri = ({ protocol, host }) => `${protocol}//${host}/`

const initialState = {}

export default handleActions(
  {
    [confirmThunk.FAILED]: (state, action) => ({ ...state, ...action.payload }),
    [confirmThunk.SUCCEEDED]: (state, action) => ({ ...state, ...action.payload }),
    [sendThunk.FAILED]: (state, action) => ({ ...state, ...action.payload }),
    [sendThunk.SUCCEEDED]: (state, action) => ({ ...state, ...action.payload })
  },
  initialState
)



// WEBPACK FOOTER //
// ./src/modules/users/confirmations.js